
<template>
  <div>
    <div class="row">
      <div class="col" style="margin-top: 7px; margin-bottom: 15px;">
        <div class="row">
          <span class="float-left" v-if="user_livello != 4 && user_livello != 5">
            <router-link :to="'/aggiungi-dati'"><button class="btn" type="button" style="background:#00467f">Crea</button></router-link>
          </span>
          <span v-else></span>
        </div>
        <div class="row">
          <!--<button class="btn float-right" type="button" v-on:click="scaricaCSV()" target="_blank" style="margin-bottom: 10px;background:#00467f">Scarica CSV</button>-->
          <span v-if="user_livello != 3 && user_livello != 4 && user_livello != 5"><a :href="urlRichieste + 'pratica/csv?token=' + access_token" target="_blank" style="color:white;font-weight: bold;"><button class="btn float-right" type="button" style="margin-bottom: 10px;background:#00467f">Scarica CSV</button></a></span>
          <span v-else></span>  
        </div>
      </div>
      
      <div class="col text-md-center float-center" style=" margin-bottom: 15px;">
        <!--<legenda />-->
        <div style="border: 2px solid;color:#00467f">
          <h4 class="card-title" style="color:#00467f"><strong>LEGENDA</strong></h4>
          <div class="row">
              <div class="col" style="text-align:center;margin-left:10px;margin-bottom:5px"><button v-on:click="filterByStatus('green')" type="button" style="border: none;background:#f5f6fa"><img src="@/assets/img/green.png" style="width:20px;margin-right:15px;margin-bottom:5px"><i style="text-decoration:underline;">COMPLETATO</i></button></div>
              <div class="col" style="text-align:center;margin-left:10px;margin-bottom:5px"><button v-on:click="filterByStatus('yellow')" type="button" style="border: none;background:#f5f6fa"><img src="@/assets/img/yellow.png" style="width:20px;margin-right:15px;margin-bottom:5px"><i style="text-decoration:underline;">COMPILA</i></button></div>
              <div class="col" style="text-align:center;margin-left:10px;margin-bottom:5px"><button v-on:click="filterByStatus('blue')" type="button" style="border: none;background:#f5f6fa"><img src="@/assets/img/blue.png" style="width:20px;margin-right:15px;margin-bottom:5px"><i style="text-decoration:underline;">ATTENDI</i></button></div>
              <div class="col" style="text-align:center;margin-left:10px;margin-bottom:5px"><button v-on:click="filterByStatus('red')" type="button" style="border: none;background:#f5f6fa"><img src="@/assets/img/red.png" style="width:20px;margin-right:15px;margin-bottom:5px"><i style="text-decoration:underline;">FALLITO</i></button></div>
          </div>
        </div>
      </div>
      <!-- LEGENDA STATI DI AVANZAMENTO-->
      <div class="col text-md-center float-center" style=" margin-bottom: 15px;">
        <div style="border: 2px solid;color:#00467f">
          <h4 class="card-title" style="color:#00467f"><strong>LEGENDA STATI DI AVANZAMENTO</strong></h4>
          <ol style="text-align:left">
            <li>Richiesta sopralluogo</li>
            <li>Accettazione supervisore Ascom</li>
            <li>Preventivo creato</li>
            <li>Accettazione supervisore Satec</li>
            <li>Preventivo accettato</li>
            <li>Accettazione supervisore Ascom</li>
            <li>Attività svolte</li>
            <li>Accettazione supervisore Ascom</li>
            <li>Pagato</li>
          </ol>
        </div>
      </div>
      
      <div class="col">
        <span class="float-right">
          <div class="search-bar input-group"  @click="searchModalVisible = true">
            <button class="btn btn-link" id="search-button" data-toggle="modal" data-target="#searchModal"><i class="tim-icons icon-zoom-split"></i>
              <span class="d-lg-none d-md-block">Search</span>
            </button>
          </div>
          <modal :show.sync="searchModalVisible"
                  class="modal-search"
                  id="searchModal"
                  :centered="false"
                  :show-close="true">
            Cerca per:<br>
            <label for="azienda" style="margin-right:10px"><input type="radio" id="azienda" value="azienda" v-model="cerca_selezionato" style="margin-right:5px">nome azienda</label>
            <label for="dipendente"><input type="radio" id="dipendente" value="dipendente" v-model="cerca_selezionato" style="margin-right:5px">nome dipendente</label>
            <input type="text" id="ricerca" class="form-control" v-on:keyup="cerca()" name="ricerca" placeholder=" Cerca...">
          </modal>
        </span>
      </div>
    </div>

    <div class="row">
      <div class="col">
        <card class="card">
          <div class="row">
            <p style="text-align:left; margin-left:20px">FILTRA PER:<br>
              <ul style="list-style-type: none;">
                <li>
                  <label style="color:black"><input type="radio" id="filtraAvanzamento" value="filtraAvanzamento" v-model="filtroScelto" style="text-align:left; margin-right:10px">STATO DI AVANZAMENTO</label>
                  <div class="row" v-if="filtroScelto == 'filtraAvanzamento'" style="margin-left:15px"><br>
                    <select v-model="avanzamento_selected" v-on:change="filtraAvanzamento()" style="border: 2.5px solid;border-radius: 0.25em;border-color:#00467f;background-color: #fff;width: 100%;max-width: 100px;margin-left:30px">
                      <option disabled value="">Please select one</option>
                      <option>Tutti</option>
                      <option value="1">1. Richiesta sopralluogo</option>
                      <option value="2">2. Accettazione supervisore Ascom</option>
                      <option value="3">3. Preventivo creato</option>
                      <option value="4">4. Accettazione supervisore Satec</option>
                      <option value="5">5. Preventivo accettato</option>
                      <option value="6">6. Accettazione supervisore Ascom</option>
                      <option value="7">7. Attività svolte</option>
                      <option value="8">8. Accettazione supervisore Ascom</option>
                      <option value="9">9. Pagato</option>
                    </select>
                    <div v-if="avanzamento_selected==2">
                      <div class="col">
                        <label><input type="radio" name="chiamato" v-model="check_chiamato" value="non_chiamato" style="margin-right:5px;margin-left:10px" v-on:change="filtraAvanzamento()">Non chiamato</label> 
                        <label><input type="radio" name="chiamato" v-model="check_chiamato" value="chiamato" style="margin-right:5px;margin-left:10px" v-on:change="filtraAvanzamento()">Chiamato</label>
                      </div>
                    </div>
                    <div v-if="avanzamento_selected==4">
                      <div class="col">
                        <label><input type="radio" name="invio_preventivo" v-model="check_inviato_preventivo_cliente" value="non_inviato" style="margin-right:5px;margin-left:10px" v-on:change="filtraAvanzamento()">Preventivo non inviato al cliente</label> 
                        <label><input type="radio" name="invio_preventivo" v-model="check_inviato_preventivo_cliente" value="inviato" style="margin-right:5px;margin-left:10px" v-on:change="filtraAvanzamento()">Preventivo inviato al cliente</label>
                      </div>
                    </div>
                  </div>
                </li>

                <li>
                  <label style="color:black"><input type="radio" id="dataDaA" value="dataDaA" v-model="filtroScelto" style="text-align:left; margin-right:10px">GIORNI</label>
                  <div class="row" style="margin-left:10px;margin-bottom:25px" v-if="filtroScelto == 'dataDaA'">
                    <div class="col">
                      <p><strong>Da giorno</strong><input type="date" class="form-control" value="17-06-2021" id="dateFrom" v-model="dateFrom" v-on:keyup.enter="cercaData()"/></p>
                    </div>
                    <div class="col">
                      <p><strong>A giorno</strong><input type="date" class="form-control" value="20-08-2021" id="dateTo" v-model="dateTo" v-on:keyup.enter="cercaData()"/></p>
                    </div>
                    <div class="col">
                      <button class="btn btn-primary" type="button" v-on:click="cercaData()" style="background:#00467f;margin-top:15px">Cerca</button>
                    </div>
                  </div>
                </li>
                <li><label style="color:black"><input type="radio" id="dataDaA" value="filtraPagate" v-model="filtroScelto" style="text-align:left; margin-right:10px" v-on:click="filterByPratichePagate()">PRATICHE PAGATE</label></li>
                <li><label style="color:black"><input type="radio" value="filtraLuogo" v-model="filtroScelto" id="filtraLuogo" style="text-align:left; margin-right:10px">LUOGO</label>
                  <div class="row" v-if="filtroScelto == 'filtraLuogo'">
                    <div class="col">
                      <input type="text" class="form-control" id="luogo" v-model="luogo" placeholder="San Donà" style="margin-left:15px;margin-top:5px" v-on:keyup.enter="filterByLuogo()"/>
                    </div>
                    <div class="col">
                      <button class="btn btn-primary" type="button" v-on:click="filterByLuogo()" style="background:#00467f">Cerca</button>
                    </div>
                  </div>
                </li>
              </ul>
            </p>
          </div>
          <div class="table-responsive">
            <div class="row justify-content-center" style="margin-bottom:40px">
              <div class="col-4">
                <div v-if="page != 1"><button v-on:click="changePage('indietro')" style="color:#00467f;padding: 0;border: none;background: none;"><i class="tim-icons icon-minimal-left" style="font-size:20px;color:#00467f"></i></button></div>
                <div v-else></div>
              </div>
              <div class="col-4">
                <p>Pagina <strong>{{page}}</strong> di <strong>{{totPage}}</strong></p>
              </div>
              <div class="col-4">
                <div v-if="page < totPage"><button v-on:click="changePage('avanti')" style="color:#00467f;padding: 0;border: none;background: none;"><i class="tim-icons icon-minimal-right" style="font-size:20px;color:#00467f"></i></button></div>
                <div v-else></div>
              </div>
            </div>
            <table class="table tablesorter" id="tabella" style="text-align: center">
              <thead>
                <tr>
                  <th @click="sort('DATA_INSERIMENTO')" style="text-decoration:underline">DATA</th>
                  <th @click="sort('AZIENDA')" style="text-decoration:underline">AZIENDA</th>
                  <th @click="sort('CODICE_FISCALE')" style="text-decoration:underline">CODICE FISCALE</th>
                  <th @click="sort('REFERENTE_AZIENDA')" style="text-decoration:underline">REFERENTE AZIENDA</th>
                  <th @click="sort('TEL')" style="text-decoration:underline">TEL</th>
                  <th @click="sort('MAIL')" style="text-decoration:underline">MAIL</th>
                  <th @click="sort('SEDE')" style="text-decoration:underline">SEDE DOVE EFFETTUARE IL SOPRALLUOGO</th>
                  <th @click="sort('TIPO')" style="text-decoration:underline">TIPO RICHIESTA</th>
                  <th @click="sort('AVANZAMENTO')" style="text-decoration:underline">AVANZAMENTO</th>
                  <th @click="sort('STATO')">STATO</th>
                  <th>UFFICIO</th>
                  <th>COGNOME NOME</th>
                  <th></th>
                </tr>
              </thead>
              <tbody>
                <tr v-for="(valori) in sortedValori" v-bind:key="valori.ID"><!-- -->
                  <td>{{getDate(valori.DATA_INSERIMENTO)}}</td>
                  <td>{{valori.AZIENDA}}</td>
                  <td>{{valori.CF}}</td>
                  <td>{{valori.REFERENTE_AZIENDA}}</td>
                  <td>{{valori.TEL}}</td>
                  <td>{{valori.MAIL}}</td>
                  <td>{{valori.SEDE}}</td>
                  <td>{{valori.TIPO}}</td>
                  <td>{{valori.AVANZAMENTO}}
                    <span v-if="valori.AVANZAMENTO==2" :style=" valori.CHIAMATO ? 'color:green' :'color:red'"><i class="fa fa-phone" style="margin-left:5px;font-size:16px"></i></span>
                    <span v-if="valori.AVANZAMENTO==4" :style=" valori.INVIO_PREVENTIVO_CLIENTE ? 'color:green' :'color:red'"><i class="fa fa-envelope " style="margin-left:5px;font-size:16px"></i></span>
                  </td>
                  <!--<td><img :src="img_check[index]" style="width:20px"></td>-->
                  <td><img :src="valori.IMMAGINE_CHECK" style="width:20px"></td>
                  <td v-if="valori.user.user_site != null">{{valori.user.user_site.UFFICIO}}</td>
                  <td v-else></td>
                  <td v-if="valori.user != null">{{valori.user.COGNOME}} {{valori.user.NOME}}</td>
                  <td v-else></td>
                  <td v-if="(valori.AVANZAMENTO == 1 && (user_livello == 1) ) 
                      || (valori.AVANZAMENTO == 2 && (user_livello == 1 || user_livello == 4 || user_livello == 5))
                      || (valori.AVANZAMENTO == 3 && (user_livello == 1 || user_livello == 4))
                      || (valori.AVANZAMENTO == 4 && (user_livello == 1 || user_livello == 2 || user_livello == 3)) 
                      || (valori.AVANZAMENTO == 5 && (user_livello == 1 || user_livello == 2))
                      || (valori.AVANZAMENTO == 6 && (user_livello == 1 || user_livello == 4 || user_livello == 5))
                      || (valori.AVANZAMENTO == 7 && (user_livello == 1))
                      || (valori.AVANZAMENTO == 8 && (user_livello == 1 || user_livello == 4 || user_livello == 5))
                      || (valori.AVANZAMENTO == 9 && valori.PAGATO == false)">
                      <!-- || (valori.AVANZAMENTO==9 && (user_livello==1 || user_livello==2 || user_livello==3 || user_livello==4 || user_livello==5))-->
                    <router-link :to="'/modifica-dati?id='+valori.ID"><i class="tim-icons icon-pencil" style="color:#00467f"></i></router-link>
                  </td>
                  <td v-else-if="(valori.AVANZAMENTO == 1)
                      || (valori.AVANZAMENTO == 2 && (user_livello != 1 || user_livello != 4 || user_livello != 5))
                      || (valori.AVANZAMENTO == 3 && (user_livello != 1 || user_livello != 4))
                      || (valori.AVANZAMENTO == 4 && (user_livello != 1 || user_livello != 2 || user_livello != 3)) 
                      || (valori.AVANZAMENTO == 5 && (user_livello != 1 || user_livello != 2))
                      || (valori.AVANZAMENTO == 6 && (user_livello != 1 || user_livello != 4 || user_livello != 5))
                      || (valori.AVANZAMENTO == 7 && (user_livello != 1))
                      || (valori.AVANZAMENTO == 8 && (user_livello != 1 || user_livello != 4 || user_livello != 5))
                      || (valori.AVANZAMENTO == 9 && valori.PAGATO == true)">
                    <router-link :to="'/modifica-dati?id='+valori.ID"><i class="tim-icons icon-zoom-split" style="color:#00467f"></i></router-link>
                    </td>
                  <td v-else></td>
                </tr>
              </tbody>
            </table>
          </div>
        </card>
      </div>
    </div>
  </div>
</template>

<script>
import axios from 'axios';
import moment from 'moment';
import Card from "../components/Cards/Card.vue";
import Modal from "@/components/Modal.vue";
import Legenda from "@/components/Legenda.vue";
import PraticheServices from '@/services/PraticheServices';
import Services from '@/services/Services';
// import Chat from '@/components/Chat.vue';
// import UserTyping from '@/components/UserTyping.vue';

export default {
  components: {
    Card,
    Modal,
    Legenda,
    // Chat
  },

  data() {
    return {
      searchModalVisible: false,
      searchQuery: '',
      page: 1,
      totPage: null,
      
      valoriConStato: [],
      allValoriConStato: [],
      img_check: [],
      avanzamento: null,
      status: null,
      token_response: '',
      valori: [],
      allPratiche: [],
      yellow_array: [],
      img_yellow: [],
      blue_array: [],
      img_blue: [],
      green_array: [],
      img_green: [],
      red_array: [],
      img_red: [],
      results: [],
      avanzamento_selected: null,
      filtra_per: null,
      check_chiamato: "chiamato",
      check_inviato_preventivo_cliente: "non_inviato",
      cerca_selezionato: "azienda",
      user_livello: null,
      //per filtrare
      dateFrom: '',
      dateTo: '',
      filtroScelto: null,
      luogo: '',
      //errore_refresh: 0,
      header:{
        headers: {
            'Content-type': 'application/json',
        }
      },
      currentSort:'DATA_INSERIMENTO',
      currentSortDir:'desc',
      access_token: null,
      urlRichieste: 'https://sviluppoallergeni.confcom.it/',//'https://apiintranet.confcom.it/'
    };
  },

  methods: {
    cerca: async function() {
      let input, filter, table, tr, td, i, txtValue;
      input = document.getElementById("ricerca");
      filter = input.value.toUpperCase();
      table = document.getElementById("tabella");
      tr = table.getElementsByTagName("tr");
      let arrayFiltrato = [];
      for (i = 0; i < this.allvaloriConStato.length; i++) {
        if (this.cerca_selezionato == "azienda") {
          txtValue = this.allvaloriConStato[i].AZIENDA;
        } else {
        txtValue = this.allvaloriConStato[i].user.COGNOME + this.allvaloriConStato[i].user.NOME;
        }
        if (txtValue.toUpperCase().indexOf(filter) > -1) {
          arrayFiltrato.push(this.allvaloriConStato[i]);
        }
      }
      this.valoriConStato = arrayFiltrato;
      if (filter == "") {
        await this.caricaPagina();
      }
    },

    cercaData: async function() {
      let errore = 0
      const token = localStorage.getItem("access_token");
      await PraticheServices.getPratiche()
      .then(response => { this.valori = response.data})
      .catch(function (error) {
        if(error.response.status == 401){
          errore = error.response.status
          console.log(`errore = ${errore}`);
        }
      });
      console.log(`errore fuori da catch = ${errore}`);
      if (errore == 401) {
        let value = await this.refreshToken();
        if (value) {
          await this.getAllPratiche();
          await this.caricaPagina();
        }
      }
      let dataDa = this.dateFrom;
      let dataA = this.dateTo;
      let arrayFiltratoDataDa = this.valori.filter( function(el) { return el.DATA_INSERIMENTO >= dataDa});
      let arrayFiltratoDataA = arrayFiltratoDataDa.filter( function(el) { return el.DATA_INSERIMENTO <= dataA});
      this.valori = arrayFiltratoDataA;
      console.log("array friltrato tra intervallo data: ");
      console.log(arrayFiltratoDataA);
      this.valoriConStato = [];
      let array = [];
      for (var i = 0; i < this.valori.length; i++) {
        if (this.valori[i].CHECK_1 == false || this.valori[i].CHECK_2 == false || this.valori[i].CHECK_3 == false || this.valori[i].CHECK_4 == false) {
          this.img_check.push(require("@/assets/img/red.png"));
          let user_siteArray = [];
          if ( this.valori[i].user.user_site == null) {
           user_siteArray = null;
          } else {
            user_siteArray = { DENOMINAZIONE: this.valori[i].user.user_site.DENOMINAZIONE, ID: this.valori[i].user.user_site.ID, UFFICIO: this.valori[i].user.user_site.UFFICIO};
          }
          let userArray = { COGNOME: this.valori[i].user.COGNOME, ID: this.valori[i].user.ID, LIVELLO: this.valori[i].user.LIVELLO, NOME: this.valori[i].user.NOME, user_site: user_siteArray};
          array = { ATTIVITA_CONFERMATE: this.valori[i].ATTIVITA_CONFERMATE,AVANZAMENTO:this.valori[i].AVANZAMENTO, AZIENDA:this.valori[i].AZIENDA, CF: this.valori[i].CF, 
          CHECK_1:this.valori[i].CHECK_1,CHECK_2:this.valori[i].CHECK_2, CHECK_3:this.valori[i].CHECK_3, CHECK_4:this.valori[i].CHECK_4, CREATA_DA:this.valori[i].CREATA_DA, 
          DATA_ACC_PREVENTIVO:this.valori[i].DATA_ACC_PREVENTIVO, 
          DATA_INVIO_PREVENTIVO_CLIENTE: this.valori[i].DATA_INVIO_PREVENTIVO_CLIENTE, INVIO_PREVENTIVO_CLIENTE: this.valori[i].INVIO_PREVENTIVO_CLIENTE,
          DATA_CHIUSURA:this.valori[i].DATA_CHIUSURA, DATA_INSERIMENTO:this.valori[i].DATA_INSERIMENTO, DATA_INVIO_PREVENTIVO:this.valori[i].DATA_INVIO_PREVENTIVO, 
          CHIAMATO: this.valori[i].CHIAMATO, APPUNTAMENTO: this.valori[i].APPUNTAMENTO, DATA_APPUNTAMENTO: this.valori[i].DATA_APPUNTAMENTO,
          DATA_SOPRALLUOGO:this.valori[i].DATA_SOPRALLUOGO, ID:this.valori[i].ID, IMPORTO_FATTURARE:this.valori[i].IMPORTO_FATTURARE, MAIL:this.valori[i].MAIL, PAGATO:this.valori[i].PAGATO, 
          PREZZO_CONSIGLIATO:this.valori[i].PREZZO_CONSIGLIATO, PREZZO_SATEC:this.valori[i].PREZZO_SATEC, REFERENTE_AZIENDA:this.valori[i].REFERENTE_AZIENDA, RIF_FT:this.valori[i].RIF_FT, SEDE:this.valori[i].SEDE, 
          TECNICO_SOPRALLUOGO:this.valori[i].TECNICO_SOPRALLUOGO, TECNICO_SVOLGIMENTO:this.valori[i].TECNICO_SVOLGIMENTO, TEL:this.valori[i].TEL, TIPO:this.valori[i].TIPO, IMMAGINE_CHECK: require('@/assets/img/red.png'), user: userArray};
          this.valoriConStato.push(array);
        } else {
          let immagine = this.caricaPalliniPagina(i);
          let user_siteArray = [];
          if ( this.valori[i].user.user_site == null) {
           user_siteArray = null;
          } else {
             user_siteArray = { DENOMINAZIONE: this.valori[i].user.user_site.DENOMINAZIONE, ID: this.valori[i].user.user_site.ID, UFFICIO: this.valori[i].user.user_site.UFFICIO};
          }
          let userArray = { COGNOME: this.valori[i].user.COGNOME, ID: this.valori[i].user.ID, LIVELLO: this.valori[i].user.LIVELLO, NOME: this.valori[i].user.NOME, user_site: user_siteArray};
          array = {ATTIVITA_CONFERMATE:this.valori[i].ATTIVITA_CONFERMATE, AVANZAMENTO:this.valori[i].AVANZAMENTO, AZIENDA: this.valori[i].AZIENDA, CF: this.valori[i].CF, 
          CHECK_1:this.valori[i].CHECK_1, CHECK_2:this.valori[i].CHECK_2, CHECK_3:this.valori[i].CHECK_3, CHECK_4:this.valori[i].CHECK_4, CREATA_DA:this.valori[i].CREATA_DA, 
          DATA_ACC_PREVENTIVO:this.valori[i].DATA_ACC_PREVENTIVO, 
          DATA_INVIO_PREVENTIVO_CLIENTE: this.valori[i].DATA_INVIO_PREVENTIVO_CLIENTE, INVIO_PREVENTIVO_CLIENTE: this.valori[i].INVIO_PREVENTIVO_CLIENTE,
          DATA_CHIUSURA:this.valori[i].DATA_CHIUSURA, DATA_INSERIMENTO:this.valori[i].DATA_INSERIMENTO, DATA_INVIO_PREVENTIVO:this.valori[i].DATA_INVIO_PREVENTIVO, 
          CHIAMATO: this.valori[i].CHIAMATO, APPUNTAMENTO: this.valori[i].APPUNTAMENTO, DATA_APPUNTAMENTO: this.valori[i].DATA_APPUNTAMENTO,
          DATA_SOPRALLUOGO:this.valori[i].DATA_SOPRALLUOGO, ID:this.valori[i].ID, IMPORTO_FATTURARE:this.valori[i].IMPORTO_FATTURARE, MAIL:this.valori[i].MAIL, PAGATO:this.valori[i].PAGATO, 
          PREZZO_CONSIGLIATO:this.valori[i].PREZZO_CONSIGLIATO, PREZZO_SATEC:this.valori[i].PREZZO_SATEC, REFERENTE_AZIENDA:this.valori[i].REFERENTE_AZIENDA, RIF_FT:this.valori[i].RIF_FT, SEDE:this.valori[i].SEDE, 
          TECNICO_SOPRALLUOGO:this.valori[i].TECNICO_SOPRALLUOGO, TECNICO_SVOLGIMENTO:this.valori[i].TECNICO_SVOLGIMENTO, TEL:this.valori[i].TEL, TIPO:this.valori[i].TIPO, IMMAGINE_CHECK: immagine, user: userArray};
          this.valoriConStato.push(array);
        }
      }
    },

    filterByPratichePagate: function() {
      this.allvaloriConStato = this.allvaloriConStato.filter( function(el) { 
        return el.PAGATO == true });
     
      this.valoriConStato = this.allvaloriConStato;
      //console.log("valori filtrati per pagato")
      //console.log(this.valoriConStato)
    },

    filterByLuogo: async function() {
      //console.log("valore luogo " + this.luogo)
      let luogoCercato = this.luogo;
      if( this.luogo == ''){
        await this.caricaPagina();
      } else {
        this.valoriConStato = this.allvaloriConStato.filter( function(el) { return el.SEDE.toLowerCase().includes(luogoCercato.toLowerCase()) == true });
        //console.log(this.valoriConStato)
      }
    },

    filtraAvanzamento: async function() {
      const token = localStorage.getItem("access_token")
      this.img_check = [];
      let errore = 0;
      console.log(`this.avanzamento_selected = ${this.avanzamento_selected}`);
      const user_id = localStorage.getItem('user_id');
      if (this.avanzamento_selected == "tutti") {
        this.page=0;
        this.changePage();
      } else {
        let url ="";
        if(localStorage.getItem('user_livello') ==  1 || localStorage.getItem('user_livello') ==  2 || localStorage.getItem('user_livello') ==  4 || localStorage.getItem('user_livello') == 5){
          url = this.urlRichieste + "pratica?filter=true&AVANZAMENTO=" + this.avanzamento_selected;
        } else {
          url = this.urlRichieste + "pratica?filter=true&AVANZAMENTO=" + this.avanzamento_selected + "&CREATA_DA=" + user_id;
        }
        await PraticheServices.filterByAvanzamento(this.avanzamento_selected)
        .then(response => { this.valori = response.data})
        .catch(function (error) {
          // handle error
          if(error.response.status == 401){
            errore = error.response.status;
            console.log(`errore = ${errore}`);
          }
        })
        console.log(`errore fuori da catch = ${errore}`);
        if (errore == 401) {
          let value = await this.refreshToken();
          if (value) {
            await this.getAllPratiche();
            await this.caricaPagina();
          }
        }
        if (this.avanzamento_selected == 2) {
          if (this.check_chiamato == "chiamato") {
            this.valori = this.valori.filter( function(el) { return el.CHIAMATO == true });
            console.log(`valori filtrati per ${this.check_chiamato}`);
            console.log(this.valori);
          }
          else {
            this.valori = this.valori.filter( function(el) { return (el.CHIAMATO == false || el.CHIAMATO == null) });
            console.log(`valori filtrati per ${this.check_chiamato}`);
            console.log(this.valori);
          }
        }
       
        if (this.avanzamento_selected == 4) {
          if (this.check_inviato_preventivo_cliente == "non_inviato") {
            this.valori = this.valori.filter( function(el) { return (el.INVIO_PREVENTIVO_CLIENTE == false || el.INVIO_PREVENTIVO_CLIENTE == null) });
            console.log(`valori filtrati per ${this.check_inviato_preventivo_cliente}`);
            console.log(this.valori);
          }
          else {
            this.valori = this.valori.filter( function(el) { return el.INVIO_PREVENTIVO_CLIENTE == true });
            console.log(`valori filtrati per ${this.check_inviato_preventivo_cliente}`);
            console.log(this.valori);
          }
        }
        
      }
      this.valoriConStato = [];
      let array = [];
      for (var i = 0; i < this.valori.length; i++) {
        if (this.valori[i].CHECK_1 == false || this.valori[i].CHECK_2 == false || this.valori[i].CHECK_3 == false || this.valori[i].CHECK_4 == false) {
          this.img_check.push(require("@/assets/img/red.png"));
          let user_siteArray = [];
         if ( this.valori[i].user.user_site == null) {
           user_siteArray = null;
          } else {
             user_siteArray = { DENOMINAZIONE: this.valori[i].user.user_site.DENOMINAZIONE, ID: this.valori[i].user.user_site.ID, UFFICIO: this.valori[i].user.user_site.UFFICIO};
          }
          let userArray = { COGNOME: this.valori[i].user.COGNOME, ID: this.valori[i].user.ID, LIVELLO: this.valori[i].user.LIVELLO, NOME: this.valori[i].user.NOME, user_site: user_siteArray};
          array = { ATTIVITA_CONFERMATE: this.valori[i].ATTIVITA_CONFERMATE,AVANZAMENTO:this.valori[i].AVANZAMENTO, AZIENDA:this.valori[i].AZIENDA, CF: this.valori[i].CF, 
          CHECK_1:this.valori[i].CHECK_1,CHECK_2:this.valori[i].CHECK_2, CHECK_3:this.valori[i].CHECK_3, CHECK_4:this.valori[i].CHECK_4, CREATA_DA:this.valori[i].CREATA_DA, 
          DATA_ACC_PREVENTIVO:this.valori[i].DATA_ACC_PREVENTIVO, 
          DATA_INVIO_PREVENTIVO_CLIENTE: this.valori[i].DATA_INVIO_PREVENTIVO_CLIENTE, INVIO_PREVENTIVO_CLIENTE: this.valori[i].INVIO_PREVENTIVO_CLIENTE,
          DATA_CHIUSURA:this.valori[i].DATA_CHIUSURA, DATA_INSERIMENTO:this.valori[i].DATA_INSERIMENTO, DATA_INVIO_PREVENTIVO:this.valori[i].DATA_INVIO_PREVENTIVO, 
          CHIAMATO: this.valori[i].CHIAMATO, APPUNTAMENTO: this.valori[i].APPUNTAMENTO, DATA_APPUNTAMENTO: this.valori[i].DATA_APPUNTAMENTO,
          DATA_SOPRALLUOGO:this.valori[i].DATA_SOPRALLUOGO, ID:this.valori[i].ID, IMPORTO_FATTURARE:this.valori[i].IMPORTO_FATTURARE, MAIL:this.valori[i].MAIL, PAGATO:this.valori[i].PAGATO, 
          PREZZO_CONSIGLIATO:this.valori[i].PREZZO_CONSIGLIATO, PREZZO_SATEC:this.valori[i].PREZZO_SATEC, REFERENTE_AZIENDA:this.valori[i].REFERENTE_AZIENDA, RIF_FT:this.valori[i].RIF_FT, SEDE:this.valori[i].SEDE, 
          TECNICO_SOPRALLUOGO:this.valori[i].TECNICO_SOPRALLUOGO, TECNICO_SVOLGIMENTO:this.valori[i].TECNICO_SVOLGIMENTO, TEL:this.valori[i].TEL, TIPO:this.valori[i].TIPO, IMMAGINE_CHECK: require('@/assets/img/red.png'), user: userArray};
          this.valoriConStato.push(array);
        } else {
          let immagine = this.caricaPalliniPagina(i);
          let user_siteArray = [];
         if ( this.valori[i].user.user_site == null) {
           user_siteArray = null;
          } else {
             user_siteArray = { DENOMINAZIONE: this.valori[i].user.user_site.DENOMINAZIONE, ID: this.valori[i].user.user_site.ID, UFFICIO: this.valori[i].user.user_site.UFFICIO};
          }
          let userArray = { COGNOME: this.valori[i].user.COGNOME, ID: this.valori[i].user.ID, LIVELLO: this.valori[i].user.LIVELLO, NOME: this.valori[i].user.NOME, user_site: user_siteArray};
          array = {ATTIVITA_CONFERMATE:this.valori[i].ATTIVITA_CONFERMATE, AVANZAMENTO:this.valori[i].AVANZAMENTO, AZIENDA: this.valori[i].AZIENDA, CF: this.valori[i].CF, 
          CHECK_1:this.valori[i].CHECK_1, CHECK_2:this.valori[i].CHECK_2, CHECK_3:this.valori[i].CHECK_3, CHECK_4:this.valori[i].CHECK_4, CREATA_DA:this.valori[i].CREATA_DA, 
          DATA_ACC_PREVENTIVO:this.valori[i].DATA_ACC_PREVENTIVO, 
          DATA_INVIO_PREVENTIVO_CLIENTE: this.valori[i].DATA_INVIO_PREVENTIVO_CLIENTE, INVIO_PREVENTIVO_CLIENTE: this.valori[i].INVIO_PREVENTIVO_CLIENTE,
          DATA_CHIUSURA:this.valori[i].DATA_CHIUSURA, DATA_INSERIMENTO:this.valori[i].DATA_INSERIMENTO, DATA_INVIO_PREVENTIVO:this.valori[i].DATA_INVIO_PREVENTIVO, 
          CHIAMATO: this.valori[i].CHIAMATO, APPUNTAMENTO: this.valori[i].APPUNTAMENTO, DATA_APPUNTAMENTO: this.valori[i].DATA_APPUNTAMENTO,
          DATA_SOPRALLUOGO:this.valori[i].DATA_SOPRALLUOGO, ID:this.valori[i].ID, IMPORTO_FATTURARE:this.valori[i].IMPORTO_FATTURARE, MAIL:this.valori[i].MAIL, PAGATO:this.valori[i].PAGATO, 
          PREZZO_CONSIGLIATO:this.valori[i].PREZZO_CONSIGLIATO, PREZZO_SATEC:this.valori[i].PREZZO_SATEC, REFERENTE_AZIENDA:this.valori[i].REFERENTE_AZIENDA, RIF_FT:this.valori[i].RIF_FT, SEDE:this.valori[i].SEDE, 
          TECNICO_SOPRALLUOGO:this.valori[i].TECNICO_SOPRALLUOGO, TECNICO_SVOLGIMENTO:this.valori[i].TECNICO_SVOLGIMENTO, TEL:this.valori[i].TEL, TIPO:this.valori[i].TIPO, IMMAGINE_CHECK: immagine, user: userArray};
          this.valoriConStato.push(array);
        }
      }
    },

    //NON UTILIZZATA
    /*
    filtraMie: async function() {
      const token = localStorage.getItem('access_token');
      this.img_check = [];
      var user_id = localStorage.getItem('user_id');
      var errore = 0;
      await axios.get(
        "https://sviluppoallergeni.confcom.it/pratica?filter=true&CREATA_DA=" + user_id,
          {
            withCredentials: true,
            headers: {
              'Content-type': 'application/json',
              'Authorization': `Bearer ${token}`
            }
          }
        ).then(response => { this.valori = response.data})
        .catch(function (error) {
          // handle error
          console.log("errore : ")
          console.log(error);
          console.log("error.status " + error.response.status)
          if(error.response.status == 401){
            errore = error.response.status
            console.log("token non valido")
            console.log("bisogna fare refresh token")
            //this.refreshToken()
          }
        })
      console.log("errore = " +errore)
      if (errore == 401) {
        await this.refreshToken()
        await this.getAllPratiche()
        await this.caricaPagina()
        console.log("rifatto richiesta a  pratiche dopo /token")
      }
      console.log("filtra per user_id = " + user_id)
      console.log(this.valori)
      this.valoriConStato = []
      var array = []
      for( var i = 0; i < this.valori.length; i++){
        if(this.valori[i].CHECK_1 == false || this.valori[i].CHECK_2 == false || this.valori[i].CHECK_3 == false || this.valori[i].CHECK_4 == false){
          this.img_check.push(require('@/assets/img/red.png'))
          array = {ATTIVITA_CONFERMATE: this.valori[i].ATTIVITA_CONFERMATE, AVANZAMENTO: this.valori[i].AVANZAMENTO, AZIENDA: this.valori[i].AZIENDA, CF: this.valori[i].CF , 
          CHECK_1: this.valori[i].CHECK_1, CHECK_2: this.valori[i].CHECK_2, CHECK_3: this.valori[i].CHECK_3, CHECK_4: this.valori[i].CHECK_4, CREATA_DA: this.valori[i].CREATA_DA, 
          DATA_ACC_PREVENTIVO: this.valori[i].DATA_ACC_PREVENTIVO, DATA_CHIUSURA: this.valori[i].DATA_CHIUSURA, DATA_INSERIMENTO: this.valori[i].DATA_INSERIMENTO, DATA_INVIO_PREVENTIVO: this.valori[i].DATA_INVIO_PREVENTIVO, 
          CHIAMATO: this.valori[i].CHIAMATO, APPUNTAMENTO: this.valori[i].APPUNTAMENTO, DATA_APPUNTAMENTO: this.valori[i].DATA_APPUNTAMENTO,
          DATA_SOPRALLUOGO: this.valori[i].DATA_SOPRALLUOGO, ID: this.valori[i].ID, IMPORTO_FATTURARE: this.valori[i].IMPORTO_FATTURARE, MAIL: this.valori[i].MAIL, PAGATO: this.valori[i].PAGATO, 
          PREZZO_CONSIGLIATO: this.valori[i].PREZZO_CONSIGLIATO, PREZZO_SATEC: this.valori[i].PREZZO_SATEC, REFERENTE_AZIENDA: this.valori[i].REFERENTE_AZIENDA, RIF_FT: this.valori[i].RIF_FT, SEDE: this.valori[i].SEDE, 
          TECNICO_SOPRALLUOGO: this.valori[i].TECNICO_SOPRALLUOGO, TECNICO_SVOLGIMENTO: this.valori[i].TECNICO_SVOLGIMENTO, TEL: this.valori[i].TEL, TIPO: this.valori[i].TIPO, IMMAGINE_CHECK: require('@/assets/img/red.png')}
          this.valoriConStato.push(array)
        } else {
          var immagine = this.caricaPalliniPagina(i)
          array = {ATTIVITA_CONFERMATE: this.valori[i].ATTIVITA_CONFERMATE, AVANZAMENTO: this.valori[i].AVANZAMENTO, AZIENDA: this.valori[i].AZIENDA, CF: this.valori[i].CF , 
          CHECK_1: this.valori[i].CHECK_1, CHECK_2: this.valori[i].CHECK_2, CHECK_3: this.valori[i].CHECK_3, CHECK_4: this.valori[i].CHECK_4, CREATA_DA: this.valori[i].CREATA_DA, 
          DATA_ACC_PREVENTIVO: this.valori[i].DATA_ACC_PREVENTIVO, DATA_CHIUSURA: this.valori[i].DATA_CHIUSURA, DATA_INSERIMENTO: this.valori[i].DATA_INSERIMENTO, DATA_INVIO_PREVENTIVO: this.valori[i].DATA_INVIO_PREVENTIVO, 
          CHIAMATO: this.valori[i].CHIAMATO, APPUNTAMENTO: this.valori[i].APPUNTAMENTO, DATA_APPUNTAMENTO: this.valori[i].DATA_APPUNTAMENTO,
          DATA_SOPRALLUOGO: this.valori[i].DATA_SOPRALLUOGO, ID: this.valori[i].ID, IMPORTO_FATTURARE: this.valori[i].IMPORTO_FATTURARE, MAIL: this.valori[i].MAIL, PAGATO: this.valori[i].PAGATO, 
          PREZZO_CONSIGLIATO: this.valori[i].PREZZO_CONSIGLIATO, PREZZO_SATEC: this.valori[i].PREZZO_SATEC, REFERENTE_AZIENDA: this.valori[i].REFERENTE_AZIENDA, RIF_FT: this.valori[i].RIF_FT, SEDE: this.valori[i].SEDE, 
          TECNICO_SOPRALLUOGO: this.valori[i].TECNICO_SOPRALLUOGO, TECNICO_SVOLGIMENTO: this.valori[i].TECNICO_SVOLGIMENTO, TEL: this.valori[i].TEL, TIPO: this.valori[i].TIPO, IMMAGINE_CHECK: immagine}
          //console.log("prova a stampare array")
          //console.log(array)
          this.valoriConStato.push(array)
          //console.log(this.valoriConStato)
        }
      }
    },
    */

    refreshToken: async function(){
      let errore = 0;
      let refreshToken = localStorage.getItem('refresh_token');
      let dati = [{ refreshToken: refreshToken}];
      let datiJSON = JSON.stringify(dati[0])
      await Services.refreshToken()
      // await axios.post(
      //   this.urlRichieste + "token", datiJSON,
      //   {
      //     withCredentials: true,
      //     headers: {
      //       'Content-type': 'application/json',
      //     }
      //   }
      // )
      .then(response => { this.token_response = response.data})
      .catch(function (error) {
        // handle error
        if(error.response.status == 403){
          errore = error.response.status;
        } else if (error.response.status == 401) {
          errore = error.response.status;
        }
      });
      console.log(`errore fuori da catch refreshToken = ${errore}`);
      if(errore == 403 || errore == 401){
        console.log(`errore = ${errore} -> fai logout`);
        await this.logout();
        return false;
      } 
      localStorage.setItem('access_token', this.token_response.accessToken);
      return true;
    },

    //OK
    caricaPallino: function(i){
      let stringaImmagine = '';
      if(this.allPratiche[i].CHECK_1 == false || this.allPratiche[i].CHECK_2 == false || this.allPratiche[i].CHECK_3 == false || this.allPratiche[i].CHECK_4 == false){
        this.red_array.push(this.allPratiche[i]);
        this.img_red.push(require('@/assets/img/red.png'));
        stringaImmagine = require('@/assets/img/red.png');
        return stringaImmagine;
      }
      else if( this.allPratiche[i].AVANZAMENTO == 1){
        //se ASCOM GIALLO
        if( localStorage.getItem('user_livello') == 2 || localStorage.getItem('user_livello') == 3){
          this.blue_array.push(this.allPratiche[i]);
          this.img_blue.push(require('@/assets/img/blue.png'));
          stringaImmagine = require('@/assets/img/blue.png');
          return stringaImmagine;
        }
        //Se SATEC BLU
        else if( localStorage.getItem('user_livello') ==  4 || localStorage.getItem('user_livello') == 5){
          //this.img_check.push(require('@/assets/img/blue.png'))
          this.blue_array.push(this.allPratiche[i]);
          this.img_blue.push(require('@/assets/img/blue.png'));
          stringaImmagine = require('@/assets/img/blue.png');
          return stringaImmagine;
        } else{
          //ADMIN 1 
          //this.img_check.push(require('@/assets/img/yellow.png'))
          this.yellow_array.push(this.allPratiche[i]);
          this.img_yellow.push(require('@/assets/img/yellow.png'));
          stringaImmagine = require('@/assets/img/yellow.png');
          return stringaImmagine;
        }
      }
      else if( this.allPratiche[i].AVANZAMENTO == 2){
        //se ASCOM BLU
        if( localStorage.getItem('user_livello') == 2 || localStorage.getItem('user_livello') == 3){
          //this.img_check.push(require('@/assets/img/blue.png'))
          this.blue_array.push(this.allPratiche[i]);
          this.img_blue.push(require('@/assets/img/blue.png'));
          stringaImmagine = require('@/assets/img/blue.png');
          return stringaImmagine;
        }
        //Se SATEC GIALLO
        else if( localStorage.getItem('user_livello') ==  4 || localStorage.getItem('user_livello') == 5){
          //this.img_check.push(require('@/assets/img/yellow.png'))
          this.img_yellow.push(require('@/assets/img/yellow.png'));
          this.yellow_array.push(this.allPratiche[i]);
          stringaImmagine = require('@/assets/img/yellow.png');
          return stringaImmagine;
        } else{
          //ADMIN 1 
          //this.img_check.push(require('@/assets/img/yellow.png'))
          this.yellow_array.push(this.allPratiche[i]);
          this.img_yellow.push(require('@/assets/img/yellow.png'));
          stringaImmagine = require('@/assets/img/yellow.png');
          return stringaImmagine;
        }
      }
      else if( this.allPratiche[i].AVANZAMENTO == 3){
        //se ASCOM BLU
        if( localStorage.getItem('user_livello') == 2 || localStorage.getItem('user_livello') == 3 || localStorage.getItem('user_livello') == 5){
          //this.img_check.push(require('@/assets/img/blue.png'))
          this.blue_array.push(this.allPratiche[i]);
          this.img_blue.push(require('@/assets/img/blue.png'));
          stringaImmagine = require('@/assets/img/blue.png');
          return stringaImmagine;
        }
        //Se SATEC BLU
        else if( localStorage.getItem('user_livello') ==  4 ){
          //this.img_check.push(require('@/assets/img/yellow.png'))
          this.yellow_array.push(this.allPratiche[i]);
          this.img_yellow.push(require('@/assets/img/yellow.png'));
          stringaImmagine = require('@/assets/img/yellow.png');
          return stringaImmagine;
        } else{
          //ADMIN 1 
          //this.img_check.push(require('@/assets/img/yellow.png'))
          this.yellow_array.push(this.allPratiche[i]);
          this.img_yellow.push(require('@/assets/img/yellow.png'));
          stringaImmagine = require('@/assets/img/yellow.png');
          return stringaImmagine;
        }
      }
      else if( this.allPratiche[i].AVANZAMENTO == 4){
        //se ASCOM GIALLO
        if( localStorage.getItem('user_livello') == 2 || localStorage.getItem('user_livello') == 3){
          //this.img_check.push(require('@/assets/img/yellow.png'))
          this.yellow_array.push(this.allPratiche[i]);
          this.img_yellow.push(require('@/assets/img/yellow.png'));
          stringaImmagine = require('@/assets/img/yellow.png');
          return stringaImmagine;
        }
        //Se SATEC BLU
        else if( localStorage.getItem('user_livello') ==  4|| localStorage.getItem('user_livello') == 5){
          //this.img_check.push(require('@/assets/img/blue.png'))
          this.blue_array.push(this.allPratiche[i]);
          this.img_blue.push(require('@/assets/img/blue.png'));
          stringaImmagine = require('@/assets/img/blue.png');
          return stringaImmagine;
        } else{
          //ADMIN 1 
          //this.img_check.push(require('@/assets/img/yellow.png'))
          this.yellow_array.push(this.allPratiche[i]);
          this.img_yellow.push(require('@/assets/img/yellow.png'));
          stringaImmagine = require('@/assets/img/yellow.png');
          return stringaImmagine;
        }
      }
      else if( this.allPratiche[i].AVANZAMENTO == 5){
        //se ASCOM BLU
        if( localStorage.getItem('user_livello') == 2){
          //this.img_check.push(require('@/assets/img/yellow.png'))
          // this.yellow_array.push(this.allPratiche[i]);
          // this.img_yellow.push(require('@/assets/img/yellow.png'));
          // stringaImmagine = require('@/assets/img/yellow.png');
          this.blue_array.push(this.allPratiche[i]);
          this.img_blue.push(require('@/assets/img/blue.png'));
          stringaImmagine = require('@/assets/img/blue.png');
          return stringaImmagine;
        }
        //Se SATEC blue
        else if( localStorage.getItem( localStorage.getItem('user_livello') == 3 || 'user_livello') ==  4 || localStorage.getItem('user_livello') == 5){
          //this.img_check.push(require('@/assets/img/blue.png'))
          this.blue_array.push(this.allPratiche[i]);
          this.img_blue.push(require('@/assets/img/blue.png'));
          stringaImmagine = require('@/assets/img/blue.png');
          return stringaImmagine;
        } else{
          //ADMIN 1 
          //this.img_check.push(require('@/assets/img/blue.png'))
          this.blue_array.push(this.allPratiche[i]);
          this.img_blue.push(require('@/assets/img/blue.png'));
          stringaImmagine = require('@/assets/img/blue.png');
          return stringaImmagine;
        }
      }
      else if( this.allPratiche[i].AVANZAMENTO == 6){
        //se ASCOM BLU
        if( localStorage.getItem('user_livello') == 2 || localStorage.getItem('user_livello') == 3){
          //this.img_check.push(require('@/assets/img/blue.png'))
          this.blue_array.push(this.allPratiche[i]);
          this.img_blue.push(require('@/assets/img/blue.png'));
          stringaImmagine = require('@/assets/img/blue.png');
          return stringaImmagine;
        }
        //Se SATEC GIALLO
        else if( localStorage.getItem('user_livello') ==  4 || localStorage.getItem('user_livello') == 5){
          //this.img_check.push(require('@/assets/img/yellow.png'))
          this.img_yellow.push(require('@/assets/img/yellow.png'));
          this.yellow_array.push(this.allPratiche[i]);
          stringaImmagine = require('@/assets/img/yellow.png');
          return stringaImmagine;
        } else{
          //ADMIN 1 
          //this.img_check.push(require('@/assets/img/yellow.png'))
          this.img_yellow.push(require('@/assets/img/yellow.png'));
          this.yellow_array.push(this.allPratiche[i]);
          stringaImmagine = require('@/assets/img/yellow.png');
          return stringaImmagine;
        }
      }
      else if( this.allPratiche[i].AVANZAMENTO == 7){
        //se ASCOM BLU
        if (localStorage.getItem('user_livello') == 2 || localStorage.getItem('user_livello') == 3) {
          //this.img_check.push(require('@/assets/img/yellow.png'))
          this.img_blue.push(require('@/assets/img/blue.png'));
          this.blue_array.push(this.allPratiche[i]);
          stringaImmagine = require('@/assets/img/blue.png');
          return stringaImmagine;
        }
        //Se SATEC BLUE
        else if( localStorage.getItem('user_livello') ==  4 || localStorage.getItem('user_livello') == 5){
          //this.img_check.push(require('@/assets/img/blue.png'))
          this.blue_array.push(this.allPratiche[i]);
          this.img_blue.push(require('@/assets/img/blue.png'));
          stringaImmagine = require('@/assets/img/blue.png');
          return stringaImmagine;
        } else{
          //ADMIN 1 
          //this.img_check.push(require('@/assets/img/yellow.png'))
          this.img_yellow.push(require('@/assets/img/yellow.png'));
          this.yellow_array.push(this.allPratiche[i]);
          stringaImmagine = require('@/assets/img/yellow.png');
          return stringaImmagine;
        }
      }
      else if( this.allPratiche[i].AVANZAMENTO == 8){
        //se ASCOM BLU
        if( localStorage.getItem('user_livello') == 2 || localStorage.getItem('user_livello') == 3){
          //this.img_check.push(require('@/assets/img/blue.png'))
          this.blue_array.push(this.allPratiche[i]);
          this.img_blue.push(require('@/assets/img/blue.png'));
          stringaImmagine = require('@/assets/img/blue.png');
          return stringaImmagine;
        }
        //Se SATEC GIALLO
        else if( localStorage.getItem('user_livello') ==  4 || localStorage.getItem('user_livello') == 5){
          //this.img_check.push(require('@/assets/img/yellow.png'))
          this.img_yellow.push(require('@/assets/img/yellow.png'));
          this.yellow_array.push(this.allPratiche[i]);
          stringaImmagine = require('@/assets/img/yellow.png');
          return stringaImmagine;
        } else{
          //ADMIN 1 
          //this.img_check.push(require('@/assets/img/yellow.png'))
          this.yellow_array.push(this.allPratiche[i]);
          this.img_yellow.push(require('@/assets/img/yellow.png'));
          stringaImmagine = require('@/assets/img/yellow.png');
          return stringaImmagine;
        }
      }
      else if( this.allPratiche[i].AVANZAMENTO == 9){
        //se ASCOM VERDE
        if( localStorage.getItem('user_livello') == 2 || localStorage.getItem('user_livello') == 3){
          //this.img_check.push(require('@/assets/img/green.png'))
          this.green_array.push(this.allPratiche[i]);
          this.img_green.push(require('@/assets/img/green.png'));
          stringaImmagine = require('@/assets/img/green.png');
          return stringaImmagine;
        }
        //Se SATEC VERDE
        else if( localStorage.getItem('user_livello') ==  4 || localStorage.getItem('user_livello') == 5){
          //this.img_check.push(require('@/assets/img/green.png'))
          this.green_array.push(this.allPratiche[i]);
          this.img_green.push(require('@/assets/img/green.png'));
          stringaImmagine = require('@/assets/img/green.png');
          return stringaImmagine;
        } else{
          //ADMIN 1 
          //this.img_check.push(require('@/assets/img/green.png'))
          this.green_array.push(this.allPratiche[i]);
          this.img_green.push(require('@/assets/img/green.png'));
          stringaImmagine = require('@/assets/img/green.png');
          return stringaImmagine;
        }
      } else{
        console.log("...");
        this.red_array.push(this.allPratiche[i]);
        this.img_red.push(require('@/assets/img/red.png'));
        stringaImmagine = require('@/assets/img/red.png');
        return stringaImmagine;
      }
    },

    caricaPalliniPagina: function(i){
      let stringStatus = '';
      if(this.valori[i].CHECK_1 == false || this.valori[i].CHECK_2 == false || this.valori[i].CHECK_3 == false || this.valori[i].CHECK_4 == false){
        this.img_check.push(require('@/assets/img/red.png'));
        stringStatus = require('@/assets/img/red.png');
        return stringStatus;
      }
      else if( this.valori[i].AVANZAMENTO == 1){
        //se ASCOM GIALLO
        if( localStorage.getItem('user_livello') == 2 || localStorage.getItem('user_livello') == 3){
          this.img_check.push(require('@/assets/img/blue.png'));
          stringStatus = require('@/assets/img/blue.png');
          return stringStatus;
        }
        //Se SATEC BLU
        else if( localStorage.getItem('user_livello') ==  4 || localStorage.getItem('user_livello') == 5){
          this.img_check.push(require('@/assets/img/blue.png'));
          stringStatus = require('@/assets/img/blue.png');
          return stringStatus;
        } else{
          //ADMIN 1 
          this.img_check.push(require('@/assets/img/yellow.png'));
          stringStatus = require('@/assets/img/yellow.png');
          return stringStatus;
        }
      }
      else if( this.valori[i].AVANZAMENTO == 2){
        //se ASCOM BLU
        if( localStorage.getItem('user_livello') == 2 || localStorage.getItem('user_livello') == 3){
          this.img_check.push(require('@/assets/img/blue.png'));
          stringStatus = require('@/assets/img/blue.png');
          return stringStatus;
        }
        //Se SATEC GIALLO
        else if( localStorage.getItem('user_livello') ==  4 || localStorage.getItem('user_livello') == 5){
          this.img_check.push(require('@/assets/img/yellow.png'));
          stringStatus = require('@/assets/img/yellow.png');
          return stringStatus;
        } else{
          //ADMIN 1 
          this.img_check.push(require('@/assets/img/yellow.png'));
          stringStatus = require('@/assets/img/yellow.png');
          return stringStatus;
        }
      }
      else if( this.valori[i].AVANZAMENTO == 3){
        //se ASCOM BLU
        if( localStorage.getItem('user_livello') == 2 || localStorage.getItem('user_livello') == 3 || localStorage.getItem('user_livello') == 5){
          this.img_check.push(require('@/assets/img/blue.png'));
          stringStatus = require('@/assets/img/blue.png');
          return stringStatus;
        }
        //Se SATEC BLU
        else if( localStorage.getItem('user_livello') ==  4 ){
          this.img_check.push(require('@/assets/img/yellow.png'));
          stringStatus = require('@/assets/img/yellow.png');
          return stringStatus;
        } else{
          //ADMIN 1 
          this.img_check.push(require('@/assets/img/yellow.png'));
          stringStatus = require('@/assets/img/yellow.png');
          return stringStatus;
        }
      }
      else if( this.valori[i].AVANZAMENTO == 4){
        //se ASCOM GIALLO
        if( localStorage.getItem('user_livello') == 2 || localStorage.getItem('user_livello') == 3){
          this.img_check.push(require('@/assets/img/yellow.png'));
          stringStatus = require('@/assets/img/yellow.png');
          return stringStatus;
        }
        //Se SATEC BLU
        else if( localStorage.getItem('user_livello') ==  4|| localStorage.getItem('user_livello') == 5){
          this.img_check.push(require('@/assets/img/blue.png'));
          stringStatus = require('@/assets/img/blue.png');
          return stringStatus;
        } else{
          //ADMIN 1 
          this.img_check.push(require('@/assets/img/yellow.png'));
          stringStatus = require('@/assets/img/yellow.png');
          return stringStatus;
        }
      }
      else if( this.valori[i].AVANZAMENTO == 5){
        //se ASCOM BLU
        if( localStorage.getItem('user_livello') == 2){
          // this.img_check.push(require('@/assets/img/yellow.png'));
          // stringStatus = require('@/assets/img/yellow.png');
          this.img_check.push(require('@/assets/img/blue.png'));
          stringStatus = require('@/assets/img/blue.png');
          return stringStatus;
        }
        //Se SATEC blue
        else if( localStorage.getItem( localStorage.getItem('user_livello') == 3 || 'user_livello') ==  4 || localStorage.getItem('user_livello') == 5){
          this.img_check.push(require('@/assets/img/blue.png'));
          stringStatus = require('@/assets/img/blue.png');
          return stringStatus;
        } else{
          //ADMIN 1 
          this.img_check.push(require('@/assets/img/blue.png'));
          stringStatus = require('@/assets/img/blue.png');
          return stringStatus;
        }
      }
      else if( this.valori[i].AVANZAMENTO == 6){
        //se ASCOM BLU
        if( localStorage.getItem('user_livello') == 2 || localStorage.getItem('user_livello') == 3){
          this.img_check.push(require('@/assets/img/blue.png'));
          stringStatus = require('@/assets/img/blue.png');
          return stringStatus;
        }
        //Se SATEC GIALLO
        else if( localStorage.getItem('user_livello') ==  4 || localStorage.getItem('user_livello') == 5){
          this.img_check.push(require('@/assets/img/yellow.png'));
          stringStatus = require('@/assets/img/yellow.png');
          return stringStatus;
        } else{
          //ADMIN 1 
          this.img_check.push(require('@/assets/img/yellow.png'));
          stringStatus = require('@/assets/img/yellow.png');
          return stringStatus;
        }
      }
      else if( this.valori[i].AVANZAMENTO == 7){
        //se ASCOM BLU
        if( localStorage.getItem('user_livello') == 2 ||  localStorage.getItem('user_livello') == 3){
          this.img_check.push(require('@/assets/img/blue.png'));
          stringStatus = require('@/assets/img/blue.png');
          return stringStatus;
        }
        //Se SATEC BLUE
        else if(  localStorage.getItem('user_livello') ==  4 || localStorage.getItem('user_livello') == 5){
          this.img_check.push(require('@/assets/img/blue.png'));
          stringStatus = require('@/assets/img/blue.png');
          return stringStatus;
        } else{
          //ADMIN 1 
          this.img_check.push(require('@/assets/img/yellow.png'));
          stringStatus = require('@/assets/img/yellow.png');
          return stringStatus;
        }
      }
      else if( this.valori[i].AVANZAMENTO == 8){
        //se ASCOM BLU
        if( localStorage.getItem('user_livello') == 2 || localStorage.getItem('user_livello') == 3){
          this.img_check.push(require('@/assets/img/blue.png'));
          stringStatus = require('@/assets/img/blue.png');
          return stringStatus;
        }
        //Se SATEC GIALLO
        else if( localStorage.getItem('user_livello') ==  4 || localStorage.getItem('user_livello') == 5){
          this.img_check.push(require('@/assets/img/yellow.png'));
          stringStatus = require('@/assets/img/yellow.png');
          return stringStatus;
        } else{
          //ADMIN 1 
          this.img_check.push(require('@/assets/img/yellow.png'));
          stringStatus = require('@/assets/img/yellow.png');
          return stringStatus;
        }
      }
      else if( this.valori[i].AVANZAMENTO == 9){
        //se ASCOM VERDE
        if( localStorage.getItem('user_livello') == 2 || localStorage.getItem('user_livello') == 3){
          this.img_check.push(require('@/assets/img/green.png'));
          stringStatus = require('@/assets/img/green.png');
          return stringStatus;
        }
        //Se SATEC VERDE
        else if( localStorage.getItem('user_livello') ==  4 || localStorage.getItem('user_livello') == 5){
          this.img_check.push(require('@/assets/img/green.png'));
          stringStatus = require('@/assets/img/green.png');
          return stringStatus;
        } else{
          //ADMIN 1 
          this.img_check.push(require('@/assets/img/green.png'));
          stringStatus = require('@/assets/img/green.png');
          return stringStatus;
        }
      } else{
        console.log("stato avanzamento sbagliato");
        this.img_check.push(require('@/assets/img/red.png'));
        stringStatus = require('@/assets/img/red.png');
        return stringStatus;
      }
    },


    //OK
    filterByStatus: function(value) {
      if( value == 'yellow'){
        this.valoriConStato = this.yellow_array;
        for(var i=0; i<this.valoriConStato.length; i++){
          this.valoriConStato[i].IMMAGINE_CHECK = require('@/assets/img/yellow.png');
        }
        this.img_check = this.img_yellow;
        return this.valoriConStato;
      }
      else if( value == 'green'){
        this.valoriConStato = this.green_array;
        this.img_check = this.img_green;
        for(var i=0; i<this.valoriConStato.length; i++){
          this.valoriConStato[i].IMMAGINE_CHECK = require('@/assets/img/green.png');
        }
        return this.valoriConStato;
      }
      else if( value == 'blue'){
        this.valoriConStato = this.blue_array;
        this.img_check = this.img_blue;
        for(var i=0; i<this.valoriConStato.length; i++){
          this.valoriConStato[i].IMMAGINE_CHECK = require('@/assets/img/blue.png');
        }
        return this.valoriConStato;
      } else {
        this.valoriConStato = this.red_array;
        this.img_check = this.img_red;
        for(var i=0; i<this.valoriConStato.length; i++){
          this.valoriConStato[i].IMMAGINE_CHECK = require('@/assets/img/red.png');
        }
        return this.valoriConStato;
      }
    },

    changePage: async function(val){
      const user_id = localStorage.getItem('user_id');
      let risposta;
      let errore = 0;
      if(val == 'avanti'){
        this.page = this.page + 1;
      } else {
        //indietro
        this.page = this.page - 1;
      }
      this.img_check = [];
      const token = localStorage.getItem('access_token');
      if(localStorage.getItem('user_livello') ==  1 || localStorage.getItem('user_livello') ==  2 || localStorage.getItem('user_livello') ==  4 || localStorage.getItem('user_livello') == 5){
        //se satec vede tutte
        await PraticheServices.changePage(this.page)
        // await axios.get(
        //   this.urlRichieste + 'pratica?page=' + this.page+'&limit=10',
        //   //'https://sviluppoallergeni.confcom.it/pratica?page='+this.page+'&limit=10', 
        //   {headers: {
        //       'Content-type': 'application/json',
        //       'Authorization': `Bearer ${token}`
        //   }}
        // )
        .then(response => { risposta = response.data})
        .catch( async function (error) {
          // handle error
          //console.log("qualcosa è andato storto")
          //console.log(error);
          //console.log("error.status " + error.response.status)
          if(error.response.status == 401){
            errore = error.response.status;
            console.log(`errore = ${errore}`);
            //console.log("bisogna fare refresh token")
            //console.log("rifatto richiesta a  pratiche dopo /token")
          }
        })
        console.log(`errore fuori da catch = ${errore}`);
        if (errore == 401) {
          let value = await this.refreshToken();
          if (value) { await this.changePage(); }
          //console.log("rifatto richiesta a  pratiche dopo /token")
        }
      } else {//se ascom ognuno vede le sue 
        await PraticheServices.changePage(this.page, user_id)
        // await axios.get(
        //   this.urlRichieste + 'pratica?page=' + this.page + '&limit=10&CREATA_DA=' + user_id,
        //   //'https://sviluppoallergeni.confcom.it/pratica?page='+this.page+'&limit=10&CREATA_DA='+user_id, 
        //   {
        //     headers: {
        //       'Content-type': 'application/json',
        //       'Authorization': `Bearer ${token}`
        //     }
        //   }
        // )
        .then(response => { risposta = response.data})
        .catch( async function (error) {
          // handle error
          if(error.response.status == 401){
            errore = error.response.status;
            console.log(`errore = ${errore}`);
          }
        })
        console.log(`errore fuori da catch = ${errore}`);
        if (errore == 401) {
          let value = await this.refreshToken();
          if (value) { await this.changePage(); }
        }
      }
      this.valori = risposta.rows;
      this.valoriConStato = [];
      let array = [];
      for (var i = 0; i < this.valori.length; i++) {
        if (this.valori[i].CHECK_1 == false || this.valori[i].CHECK_2 == false || this.valori[i].CHECK_3 == false || this.valori[i].CHECK_4 == false) {
          this.img_check.push(require('@/assets/img/red.png'));
          let user_siteArray = [];
          if ( this.valori[i].user.user_site == null) {
           user_siteArray = null;
          } else {
            user_siteArray = { DENOMINAZIONE: this.valori[i].user.user_site.DENOMINAZIONE, ID: this.valori[i].user.user_site.ID, UFFICIO: this.valori[i].user.user_site.UFFICIO};
          }
          let userArray = { COGNOME: this.valori[i].user.COGNOME, ID: this.valori[i].user.ID, LIVELLO: this.valori[i].user.LIVELLO, NOME: this.valori[i].user.NOME, user_site: user_siteArray};
          array = {ATTIVITA_CONFERMATE: this.valori[i].ATTIVITA_CONFERMATE, AVANZAMENTO: this.valori[i].AVANZAMENTO, AZIENDA: this.valori[i].AZIENDA, CF: this.valori[i].CF, 
          CHECK_1: this.valori[i].CHECK_1, CHECK_2: this.valori[i].CHECK_2, CHECK_3: this.valori[i].CHECK_3, CHECK_4: this.valori[i].CHECK_4, CREATA_DA: this.valori[i].CREATA_DA, 
          DATA_ACC_PREVENTIVO: this.valori[i].DATA_ACC_PREVENTIVO,DATA_INVIO_PREVENTIVO_CLIENTE: this.valori[i].DATA_INVIO_PREVENTIVO_CLIENTE, INVIO_PREVENTIVO_CLIENTE: this.valori[i].INVIO_PREVENTIVO_CLIENTE,
          DATA_CHIUSURA: this.valori[i].DATA_CHIUSURA, DATA_INSERIMENTO: this.valori[i].DATA_INSERIMENTO, DATA_INVIO_PREVENTIVO: this.valori[i].DATA_INVIO_PREVENTIVO, 
          CHIAMATO: this.valori[i].CHIAMATO, APPUNTAMENTO: this.valori[i].APPUNTAMENTO, DATA_APPUNTAMENTO: this.valori[i].DATA_APPUNTAMENTO,
          DATA_SOPRALLUOGO: this.valori[i].DATA_SOPRALLUOGO, ID: this.valori[i].ID, IMPORTO_FATTURARE: this.valori[i].IMPORTO_FATTURARE, MAIL: this.valori[i].MAIL, PAGATO: this.valori[i].PAGATO, 
          PREZZO_CONSIGLIATO: this.valori[i].PREZZO_CONSIGLIATO, PREZZO_SATEC: this.valori[i].PREZZO_SATEC, REFERENTE_AZIENDA: this.valori[i].REFERENTE_AZIENDA, RIF_FT: this.valori[i].RIF_FT, SEDE: this.valori[i].SEDE, 
          TECNICO_SOPRALLUOGO: this.valori[i].TECNICO_SOPRALLUOGO, TECNICO_SVOLGIMENTO: this.valori[i].TECNICO_SVOLGIMENTO, TEL: this.valori[i].TEL, TIPO: this.valori[i].TIPO, IMMAGINE_CHECK: require('@/assets/img/red.png'), user: userArray}
          this.valoriConStato.push(array);
        } else {
          let immagine = this.caricaPalliniPagina(i);
          let user_siteArray = [];
         if ( this.valori[i].user.user_site == null) {
           user_siteArray = null;
          } else {
            user_siteArray = { DENOMINAZIONE: this.valori[i].user.user_site.DENOMINAZIONE, ID: this.valori[i].user.user_site.ID, UFFICIO: this.valori[i].user.user_site.UFFICIO};
          }
          let userArray = { COGNOME: this.valori[i].user.COGNOME, ID: this.valori[i].user.ID, LIVELLO: this.valori[i].user.LIVELLO, NOME: this.valori[i].user.NOME, user_site: user_siteArray};
          array = {ATTIVITA_CONFERMATE: this.valori[i].ATTIVITA_CONFERMATE, AVANZAMENTO: this.valori[i].AVANZAMENTO, AZIENDA: this.valori[i].AZIENDA, CF: this.valori[i].CF, 
          CHECK_1: this.valori[i].CHECK_1, CHECK_2: this.valori[i].CHECK_2, CHECK_3: this.valori[i].CHECK_3, CHECK_4: this.valori[i].CHECK_4, CREATA_DA: this.valori[i].CREATA_DA, 
          DATA_ACC_PREVENTIVO: this.valori[i].DATA_ACC_PREVENTIVO, 
          DATA_INVIO_PREVENTIVO_CLIENTE: this.valori[i].DATA_INVIO_PREVENTIVO_CLIENTE, INVIO_PREVENTIVO_CLIENTE: this.valori[i].INVIO_PREVENTIVO_CLIENTE,
          DATA_CHIUSURA: this.valori[i].DATA_CHIUSURA, DATA_INSERIMENTO: this.valori[i].DATA_INSERIMENTO, DATA_INVIO_PREVENTIVO: this.valori[i].DATA_INVIO_PREVENTIVO, 
          CHIAMATO: this.valori[i].CHIAMATO, APPUNTAMENTO: this.valori[i].APPUNTAMENTO, DATA_APPUNTAMENTO: this.valori[i].DATA_APPUNTAMENTO,
          DATA_SOPRALLUOGO: this.valori[i].DATA_SOPRALLUOGO, ID: this.valori[i].ID, IMPORTO_FATTURARE: this.valori[i].IMPORTO_FATTURARE, MAIL: this.valori[i].MAIL, PAGATO: this.valori[i].PAGATO, 
          PREZZO_CONSIGLIATO: this.valori[i].PREZZO_CONSIGLIATO, PREZZO_SATEC: this.valori[i].PREZZO_SATEC, REFERENTE_AZIENDA: this.valori[i].REFERENTE_AZIENDA, RIF_FT: this.valori[i].RIF_FT, SEDE: this.valori[i].SEDE, 
          TECNICO_SOPRALLUOGO: this.valori[i].TECNICO_SOPRALLUOGO, TECNICO_SVOLGIMENTO: this.valori[i].TECNICO_SVOLGIMENTO, TEL: this.valori[i].TEL, TIPO: this.valori[i].TIPO, IMMAGINE_CHECK: immagine, user: userArray}
          this.valoriConStato.push(array);
        }
      }
    },

    caricaPagina: async function(){
      const token = localStorage.getItem('access_token');
      let user_id = localStorage.getItem('user_id');
      let isLogged = localStorage.getItem('isLogged');
      let risposta;
      this.img_check = [];
      let errore = 0;
      if(localStorage.getItem('user_livello') ==  1 || localStorage.getItem('user_livello') ==  2 || localStorage.getItem('user_livello') ==  4 || localStorage.getItem('user_livello') == 5){
        //se satec vede tutte 
        await PraticheServices.get10Pratiche()
        // await axios.get(
        //   this.urlRichieste + 'pratica?page=1&limit=10',
        //   //'https://sviluppoallergeni.confcom.it/pratica?page=1&limit=10', 
        //   {
        //     headers: {
        //       'Content-type': 'application/json',
        //       'Authorization': `Bearer ${token}`
        //     }
        //   }
        // )
        .then(response => { risposta = response.data})
        .catch( async function (error) {
          // handle error
          if(error.response.status == 401){
            errore = error.response.status;
            console.log(`errore = ${errore}`);
          }
        })
        console.log(`errore fuori da catch = ${errore}`);
        console.log(`typeof isLogged = ${typeof isLogged}`);
         if (errore == 401 && isLogged == true){
          let value = await this.refreshToken();
          if (value) { await this.caricaPagina(); }
          //console.log("rifatto richiesta a  pratiche dopo /token")
        } else if (errore == 401 && isLogged == false) {
          await this.logout();
          this.$router.push({
            path: '/login'
          })
        }
      } else {
        //se ascom vede solo le sue
        await PraticheServices.get10PraticheUtente(user_id)
        // await axios.get(
        //   this.urlRichieste + 'pratica?filter=true&page=1&limit=10&CREATA_DA=' +  user_id,
        // //'https://sviluppoallergeni.confcom.it/pratica?filter=true&page=1&limit=10&CREATA_DA=' + user_id, 
        // {
        //   headers: {
        //     'Content-type': 'application/json',
        //     'Authorization': `Bearer ${token}`
        //   }
        // }
        // )
        .then(response => { risposta = response.data})
        .catch( async function (error) {
          // handle error
          if(error.response.status == 401){
            errore = error.response.status;
            console.log(`errore = ${errore}`);
          }
        })
        console.log(`errore fuori da catch = ${errore}`);
        if (errore == 401 && isLogged == true){
          let value = await this.refreshToken();
          if (value) { await this.caricaPagina(); }
          //console.log("rifatto richiesta a  pratiche dopo /token")
        } else if (errore == 401 && isLogged == false) {
          await this.logout();
          this.$router.push({
            path: '/login'
          })
        }
      }
      this.valori = risposta.rows;
      this.valoriConStato = [];
      // Faciamo che ne mostro 10 per pagina
      var total = this.allPratiche.length;
      this.totPage = Math.ceil(total/10);
      var array = [];
      for (var i = 0; i < this.valori.length; i++) {
        if (this.valori[i].CHECK_1 == false || this.valori[i].CHECK_2 == false || this.valori[i].CHECK_3 == false || this.valori[i].CHECK_4 == false || this.valori[i].AVANZAMENTO > 9) {
          this.img_check.push(require('@/assets/img/red.png'));
          let user_siteArray = [];
         if ( this.valori[i].user.user_site == null) {
           user_siteArray = null;
          } else {
            user_siteArray = { DENOMINAZIONE: this.valori[i].user.user_site.DENOMINAZIONE, ID: this.valori[i].user.user_site.ID, UFFICIO: this.valori[i].user.user_site.UFFICIO};
          }
          let userArray = { COGNOME: this.valori[i].user.COGNOME, ID: this.valori[i].user.ID, LIVELLO: this.valori[i].user.LIVELLO, NOME: this.valori[i].user.NOME, user_site: user_siteArray};
          array = {ATTIVITA_CONFERMATE: this.valori[i].ATTIVITA_CONFERMATE, AVANZAMENTO: this.valori[i].AVANZAMENTO, AZIENDA: this.valori[i].AZIENDA, CF: this.valori[i].CF, 
          CHECK_1:this.valori[i].CHECK_1, CHECK_2: this.valori[i].CHECK_2, CHECK_3: this.valori[i].CHECK_3, CHECK_4: this.valori[i].CHECK_4, CREATA_DA: this.valori[i].CREATA_DA, 
          CHIAMATO: this.valori[i].CHIAMATO, APPUNTAMENTO: this.valori[i].APPUNTAMENTO, DATA_APPUNTAMENTO: this.valori[i].DATA_APPUNTAMENTO,
          DATA_ACC_PREVENTIVO: this.valori[i].DATA_ACC_PREVENTIVO, 
          DATA_INVIO_PREVENTIVO_CLIENTE: this.valori[i].DATA_INVIO_PREVENTIVO_CLIENTE, INVIO_PREVENTIVO_CLIENTE: this.valori[i].INVIO_PREVENTIVO_CLIENTE,
          DATA_CHIUSURA: this.valori[i].DATA_CHIUSURA, DATA_INSERIMENTO: this.valori[i].DATA_INSERIMENTO, DATA_INVIO_PREVENTIVO: this.valori[i].DATA_INVIO_PREVENTIVO, 
          DATA_SOPRALLUOGO: this.valori[i].DATA_SOPRALLUOGO, ID: this.valori[i].ID, IMPORTO_FATTURARE: this.valori[i].IMPORTO_FATTURARE, MAIL: this.valori[i].MAIL, PAGATO: this.valori[i].PAGATO, 
          PREZZO_CONSIGLIATO: this.valori[i].PREZZO_CONSIGLIATO, PREZZO_SATEC: this.valori[i].PREZZO_SATEC, REFERENTE_AZIENDA: this.valori[i].REFERENTE_AZIENDA, RIF_FT: this.valori[i].RIF_FT, SEDE: this.valori[i].SEDE, 
          TECNICO_SOPRALLUOGO: this.valori[i].TECNICO_SOPRALLUOGO, TECNICO_SVOLGIMENTO: this.valori[i].TECNICO_SVOLGIMENTO, TEL: this.valori[i].TEL, TIPO: this.valori[i].TIPO, IMMAGINE_CHECK: require('@/assets/img/red.png'), user: userArray};
          this.valoriConStato.push(array);
        } else {
          var immagine = this.caricaPalliniPagina(i);
          let user_siteArray = [];
         if ( this.valori[i].user.user_site == null) {
           user_siteArray = null;
          } else {
            user_siteArray = { DENOMINAZIONE: this.valori[i].user.user_site.DENOMINAZIONE, ID: this.valori[i].user.user_site.ID, UFFICIO: this.valori[i].user.user_site.UFFICIO};
          }
          let userArray = { COGNOME: this.valori[i].user.COGNOME, ID: this.valori[i].user.ID, LIVELLO: this.valori[i].user.LIVELLO, NOME: this.valori[i].user.NOME, user_site: user_siteArray};
          array = {ATTIVITA_CONFERMATE: this.valori[i].ATTIVITA_CONFERMATE, AVANZAMENTO: this.valori[i].AVANZAMENTO, AZIENDA: this.valori[i].AZIENDA, CF: this.valori[i].CF , 
          CHECK_1: this.valori[i].CHECK_1, CHECK_2: this.valori[i].CHECK_2, CHECK_3: this.valori[i].CHECK_3, CHECK_4: this.valori[i].CHECK_4, CREATA_DA: this.valori[i].CREATA_DA, 
          DATA_ACC_PREVENTIVO: this.valori[i].DATA_ACC_PREVENTIVO,
          DATA_INVIO_PREVENTIVO_CLIENTE: this.valori[i].DATA_INVIO_PREVENTIVO_CLIENTE, INVIO_PREVENTIVO_CLIENTE: this.valori[i].INVIO_PREVENTIVO_CLIENTE,
          DATA_CHIUSURA: this.valori[i].DATA_CHIUSURA, DATA_INSERIMENTO: this.valori[i].DATA_INSERIMENTO, DATA_INVIO_PREVENTIVO: this.valori[i].DATA_INVIO_PREVENTIVO, 
          CHIAMATO: this.valori[i].CHIAMATO, APPUNTAMENTO: this.valori[i].APPUNTAMENTO, DATA_APPUNTAMENTO: this.valori[i].DATA_APPUNTAMENTO,
          DATA_SOPRALLUOGO: this.valori[i].DATA_SOPRALLUOGO, ID: this.valori[i].ID, IMPORTO_FATTURARE: this.valori[i].IMPORTO_FATTURARE, MAIL: this.valori[i].MAIL, PAGATO: this.valori[i].PAGATO, 
          PREZZO_CONSIGLIATO: this.valori[i].PREZZO_CONSIGLIATO, PREZZO_SATEC: this.valori[i].PREZZO_SATEC, REFERENTE_AZIENDA: this.valori[i].REFERENTE_AZIENDA, RIF_FT: this.valori[i].RIF_FT, SEDE: this.valori[i].SEDE, 
          TECNICO_SOPRALLUOGO: this.valori[i].TECNICO_SOPRALLUOGO, TECNICO_SVOLGIMENTO: this.valori[i].TECNICO_SVOLGIMENTO, TEL: this.valori[i].TEL, TIPO: this.valori[i].TIPO, IMMAGINE_CHECK: immagine, user: userArray};
          this.valoriConStato.push(array);
        }
      }
    },

    getAllPratiche: async function(){
      const token = localStorage.getItem('access_token');
      let user_id = localStorage.getItem('user_id');
      let isLogged = localStorage.getItem('isLogged');
      let errore = 0;
      //se satec vede tutte
      if (localStorage.getItem('user_livello') ==  1 || localStorage.getItem('user_livello') ==  2 || localStorage.getItem('user_livello') ==  4 || localStorage.getItem('user_livello') == 5) {
        await PraticheServices.getPratiche()
        // await axios.get(
        //   this.urlRichieste + 'pratica',
        //   //'https://sviluppoallergeni.confcom.it/pratica', 
        //   {
        //     headers: {
        //       'Content-type': 'application/json',
        //       'Authorization': `Bearer ${token}`
        //     }
        //   }
        //   )
          .then(response => {this.allPratiche = response.data})
          .catch(function (error) {
            // handle error
            if (error.response.status == 401) {
              errore = error.response.status;
            }
          });
          //.finally(async function() {
            console.log(`errore fuori da catch = ${errore}`);
            if (errore == 401){//&& isLogged == true
              console.log(`errore = ${errore}`);
              let value = await this.refreshToken();
              if (value) { await this.getAllPratiche(); }
            }/* else if (errore == 401 && isLogged == false) {
              this.logout();
              this.$router.push({
                path: '/login'
              });
            }*/
          //});
          
      } else {  //se ascom vede solo le sue
        await PraticheServices.getPraticheUtente(user_id)
        // await axios.get(
        //   this.urlRichieste + 'pratica?filter=true&CREATA_DA=' + user_id,
        // //'https://sviluppoallergeni.confcom.it/pratica?filter=true&CREATA_DA=' + user_id, 
        // {
        //   headers: {
        //     'Content-type': 'application/json',
        //     'Authorization': `Bearer ${token}`
        //   }
        // }
        // )
        .then(response => { this.allPratiche = response.data})
        .catch( async function (error) {
          // handle error
          if(error.response.status == 401){
            errore = error.response.status;
            console.log(`errore = ${errore}`);
          }
        });//.finally(async function(){
          console.log(`FINALLY`);
          console.log(`errore fuori da catch = ${errore}`);
          if (errore == 401){ //&& isLogged == true
            let value = await this.refreshToken();
            if (value) { await this.getAllPratiche(); }
          }/* else if (errore == 401 && isLogged == false) {
            await this.logout();
            this.$router.push({
              path: '/login'
            })
          }*/
        //});
      }
      this.allvaloriConStato = [];
      //console.log("numero tot pratiche " + this.allPratiche.length)
      for(var i = 0; i < this.allPratiche.length; i++){
        let immagine = this.caricaPallino(i);
        let user_siteArray = [];
        if ( this.allPratiche[i].user.user_site == null) {
          user_siteArray = null;
        } else {
          user_siteArray = { DENOMINAZIONE: this.allPratiche[i].user.user_site.DENOMINAZIONE, ID: this.allPratiche[i].user.user_site.ID, UFFICIO: this.allPratiche[i].user.user_site.UFFICIO};
        }
        let userArray = { COGNOME: this.allPratiche[i].user.COGNOME, ID: this.allPratiche[i].user.ID, LIVELLO: this.allPratiche[i].user.LIVELLO, NOME: this.allPratiche[i].user.NOME, user_site: user_siteArray};
        let array = {ATTIVITA_CONFERMATE: this.allPratiche[i].ATTIVITA_CONFERMATE, AVANZAMENTO: this.allPratiche[i].AVANZAMENTO, AZIENDA: this.allPratiche[i].AZIENDA, CF: this.allPratiche[i].CF , 
        CHECK_1: this.allPratiche[i].CHECK_1, CHECK_2: this.allPratiche[i].CHECK_2, CHECK_3: this.allPratiche[i].CHECK_3, CHECK_4: this.allPratiche[i].CHECK_4, CREATA_DA: this.allPratiche[i].CREATA_DA, 
        DATA_ACC_PREVENTIVO: this.allPratiche[i].DATA_ACC_PREVENTIVO, 
        DATA_INVIO_PREVENTIVO_CLIENTE: this.allPratiche[i].DATA_INVIO_PREVENTIVO_CLIENTE, INVIO_PREVENTIVO_CLIENTE: this.allPratiche[i].INVIO_PREVENTIVO_CLIENTE,
        DATA_CHIUSURA: this.allPratiche[i].DATA_CHIUSURA, DATA_INSERIMENTO: this.allPratiche[i].DATA_INSERIMENTO, DATA_INVIO_PREVENTIVO: this.allPratiche[i].DATA_INVIO_PREVENTIVO, 
        CHIAMATO: this.allPratiche[i].CHIAMATO, APPUNTAMENTO: this.allPratiche[i].APPUNTAMENTO, DATA_APPUNTAMENTO: this.allPratiche[i].DATA_APPUNTAMENTO,
        DATA_SOPRALLUOGO: this.allPratiche[i].DATA_SOPRALLUOGO, ID: this.allPratiche[i].ID, IMPORTO_FATTURARE: this.allPratiche[i].IMPORTO_FATTURARE, MAIL: this.allPratiche[i].MAIL, PAGATO: this.allPratiche[i].PAGATO, 
        PREZZO_CONSIGLIATO: this.allPratiche[i].PREZZO_CONSIGLIATO, PREZZO_SATEC: this.allPratiche[i].PREZZO_SATEC, REFERENTE_AZIENDA: this.allPratiche[i].REFERENTE_AZIENDA, RIF_FT: this.allPratiche[i].RIF_FT, SEDE: this.allPratiche[i].SEDE, 
        TECNICO_SOPRALLUOGO: this.allPratiche[i].TECNICO_SOPRALLUOGO, TECNICO_SVOLGIMENTO: this.allPratiche[i].TECNICO_SVOLGIMENTO, TEL: this.allPratiche[i].TEL, TIPO: this.allPratiche[i].TIPO, IMMAGINE_CHECK: immagine, user: userArray};
        this.allvaloriConStato.push(array);
      }
      console.log(this.allPratiche);
    },

    logout: async function () {
      let token = localStorage.getItem('access_token');
      await Services.logout()
      // await axios.delete(
      //   this.urlRichieste + 'logout',
      //   //'https://sviluppoallergeni.confcom.it/logout',
      //     {
      //     withCredentials: true,
      //     headers: {
      //       'Content-type': 'application/json',
      //       //'Authorization': `Bearer ${token}`
      //     }
      //   }
      // )
      .then(response => { this.results = response.data});
      localStorage.removeItem('access_token');
      localStorage.removeItem('refresh_token');
      localStorage.setItem('isLogged', false);
      localStorage.removeItem('user_nome');
      localStorage.removeItem('user_cognome');
      localStorage.removeItem('user_tipologia');
      localStorage.removeItem('user_email');
      localStorage.removeItem('user_livello');
      localStorage.removeItem('user_id');
      this.$router.push({
        path: '/login'
      })
    },

    sort:function(s) {
      //if s == current sort, reverse
      if(s === this.currentSort) {
        this.currentSortDir = this.currentSortDir==='asc'?'desc':'asc';
      }
      this.currentSort = s;
    },

    main: async function() {
      axios.defaults.withCredentials = true;
      this.user_livello = localStorage.getItem('user_livello');
      console.log(`user_livello: ${this.user_livello}`)
      this.access_token = localStorage.getItem("access_token");
      try {
        await this.getAllPratiche();
        await this.caricaPagina();
      } catch (error) {
        console.log(`error try/catch = ${error}`);
        console.log(`error.response try/catch = ${error.response}`);
        console.log(`error.response.status try/catch = ${error.response.status}`);
        if (error.response.status == 401) {
          await this.refreshToken();
        }
      }
    },

    getDate(datetime) {
      return moment(String(datetime)).format('DD-MM-YYYY');
    }
  },

  mounted() {
    this.main();
  },

  computed:{
    sortedValori:function() {
      return this.valoriConStato.sort((a,b) => {
        let modifier = 1;
        if(this.currentSortDir === 'desc') modifier = -1;
        if(a[this.currentSort] < b[this.currentSort]) return -1 * modifier;
        if(a[this.currentSort] > b[this.currentSort]) return 1 * modifier;
        return 0;
      });
    },
  },

  beforeMount: function(){},
};
</script>
<style scoped>
.arrow {
  border: solid #00467f;
  border-width: 0 3px 3px 0;
  background: white;
  display: inline-block;
  padding: 7px;
}

.right {
  transform: rotate(-45deg);
}

.left {
  transform: rotate(135deg);
}

@media screen and (max-width: 500px) {
  .hidemobile {
    display: none;
  }
}
@media screen and (min-width: 500px) {
  .hidecomputer {
    display:  none;
  }
}

body {
  font-family: Roboto,sans-serif;
}
button, input, optgroup, select, textarea {
    font-family: Roboto,sans-serif;
}
</style>
